import { trackSiteGlueEvent } from "~/lib/siteglue/cta-config";
import { readMarketingAttribution } from "~/lib/siteglue/marketing-attribution";

import { isFunnelEventName, publicFunnelProps, type FunnelEventName } from "./funnel";

const SESSION_KEY = "siteglue-agentready-session";

export function agentReadySessionId(): string {
  if (typeof window === "undefined") return "server";
  const existing = window.sessionStorage.getItem(SESSION_KEY);
  if (existing) return existing;
  const next = window.crypto.randomUUID();
  window.sessionStorage.setItem(SESSION_KEY, next);
  return next;
}

export function trackAgentReadyEvent(
  name: FunnelEventName,
  extra?: Record<string, unknown>,
): void {
  if (typeof window === "undefined" || !isFunnelEventName(name)) return;
  const safe = publicFunnelProps(extra ?? {});
  trackSiteGlueEvent(name, safe);
  const payload = {
    name,
    sessionId: agentReadySessionId(),
    ...safe,
    attribution: readMarketingAttribution(),
  };
  void fetch("/api/siteglue/scan-events", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).catch(() => undefined);
}
